import React from 'react';

import ValueRow from './ValueRow';

interface ValueRowItem {
  title: string;
  value: number | string;
  color: string;
}

interface ValueRowsProps {
  data: ValueRowItem[];
}

const ValueRows: React.FC<ValueRowsProps> = ({ data }) => (
  <div className="d-flex flex-column gap-3">
    {data.map(({ title, value, color }) => (
      <ValueRow key={`${title}-${value}`} title={title} value={value} color={color} />
    ))}
  </div>
);

export default ValueRows;
